import React from 'react'
import { IdealImage } from './IdealImage'
import { useTranslation } from 'next-i18next'

type Props = {
  route: Route
  h1: string
}

export function Route({ route, h1 }: Props) {
  const { t } = useTranslation('common')
  return (
    <div className="flex flex-col items-center mx-3 xs:mx-0 xs:mt-14 my-10 gap-3">
      <div className="top-3 left-3 md:text-3xl text-xl text-basis font-medium text-center uppercase md:mb-3">
        {t('route') + ' - ' + h1}
      </div>
      {route.images.map((image, i) => (
        <div key={i} className="relative w-full rounded-lg overflow-hidden">
          <IdealImage image={image} autoheight />
        </div>
      ))}
    </div>
  )
}
